import React, { memo, useEffect, useRef, useState } from "react";
import Lottie, { LottieRefCurrentProps } from "lottie-react";
import invoiceAnimation from "ui/theme/animations/invoice.json";

import Logo from "ui/modules/public/components/Logo/Logo";

const NotificationSummaryCard: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const lottieRef = useRef<LottieRefCurrentProps>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (inView && lottieRef.current) {
      lottieRef.current.setSpeed(0.5);
      lottieRef.current.goToAndPlay(0);
    }
  }, [inView]);

  const handleLoopComplete = () => {
    if (lottieRef.current) {
      lottieRef.current.stop();
      const totalFrames = lottieRef.current.getDuration(true) ?? 0;
      if (totalFrames > 0) {
        lottieRef.current.goToAndStop(totalFrames - 1, true);
      }
    }
  };

  const isTextVisible = inView;

  return (
    <div
      ref={containerRef}
      // `h-full`, ne `h-screen` — panel introa već ima visinu modala, a `h-screen` bi ga
      // prerastao. `relative` je zbog logotipa, koji je apsolutno pozicioniran.
      className="bg-blue-700 h-full w-full min-w-0 max-w-full relative overflow-hidden flex flex-col"
    >
      <Logo
        variant="light"
        animated
        className={`absolute top-8 left-8 transition-opacity duration-700 delay-300 ${isTextVisible ? "opacity-100" : "opacity-0"}`}
      />

      <div className="flex-1 flex flex-col items-center justify-center px-6">
        <Lottie
          lottieRef={lottieRef}
          animationData={invoiceAnimation}
          autoplay={false}
          loop={true}
          onLoopComplete={handleLoopComplete}
          className="w-[500px] h-auto"
        />
        <div
          className={`
            text-center transition-all duration-700 ease-out delay-500 max-w-md
            ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-16"}
          `}
        >
          <h1 className="text-4xl leading-[46px] font-bold mb-3 text-white">
            Kreirajte notifikaciju u par koraka
          </h1>
          <p className="text-lg opacity-80 text-blue-50">
            Odaberite tip entiteta, primatelje i pravila slanja. Vodimo vas
            korak po korak.
          </p>
        </div>
      </div>
    </div>
  );
};

export default memo(NotificationSummaryCard);
